import { render, staticRenderFns } from "./listgroup.vue?vue&type=template&id=5e20468c"
import script from "./listgroup.vue?vue&type=script&lang=js"
export * from "./listgroup.vue?vue&type=script&lang=js"
import style0 from "./listgroup.vue?vue&type=style&index=0&id=5e20468c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports